import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMedicineTablett: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="medicine-tablett, pill" maskId="round-filled-radius-0-stroke-1.5-IconMedicineTablett"><path d="M11.4683 3.97024C13.8322 1.60628 17.665 1.60627 20.0289 3.97024C22.3929 6.3342 22.3929 10.1669 20.0289 12.5309L16.8093 15.7506L8.24861 7.18991L11.4683 3.97024Z" fill="currentColor"/><path d="M7.18795 8.25057L3.96828 11.4702C1.60432 13.8342 1.60432 17.6669 3.96828 20.0309C6.33224 22.3949 10.165 22.3949 12.5289 20.0309L15.7486 16.8112L7.18795 8.25057Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMedicineTablett;
